import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    tableTitle: {
      color: props.color2,
      fontWeight: 400,
      fontSize: 20,
      textTransform: 'uppercase',
      padding: '20px 20px 10px 20px',
    },
    container: {
      width: 'calc(100% - 20px)',
      marginBottom: 20,
    },
    table: {
      minWidth: 650,
      width: 'calc(100% - 50px)',
      margin: '15px 25px',
      '& .MuiTableCell-head': {
        color: '#989898',
        fontSize: 13,
        fontWeight: 400,
        borderBottomWidth: 2,
      },
      '& .MuiTableCell-body': {
        color: '#989898',
        fontSize: '13px !important',
        fontWeight: 200,
        '& svg': {
          fontSize: '13px !important',
          fill: '#989898'
        }
      },
      '& .MuiTableRow-root': {
        cursor: 'pointer'
      }
    },
    importListItem: {
      color: `${props.color2} !important`,
      fontWeight: '400 !important',
      opacity: '0.8',
    },
    responsiveContainer: {
      padding: 15,
      width: 'calc(100% - 20px)',
      color: '#989898',
      fontSize: 13,
      borderBottom:'1px solid #989898',
      '& .label': { fontWeight: 400, marginBottom: 10 },
      '& .text': { fontWeight: 200, marginBottom: 10 },
    },

    '@media (max-width: 600px)': {
      container: {
        width: '100%',
        marginBottom: 0,
      },
      table: {
        width: '100%',
        margin: 0,
      },
      responsiveContainer: {
        position: 'relative',
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px 52px 10px 10px',
        marginBottom: 10,
        border: '1px solid rgba(17,24,39,0.10)',
        borderRadius: 10,
        background: '#FFFFFF',
        color: 'var(--text-body)',
        fontSize: '0.95rem',
        lineHeight: 1.45,

        '& .label': {
          color: 'var(--text-muted)',
          fontWeight: 500,
          marginBottom: 4,
          fontSize: '0.78rem',
          letterSpacing: 0.2,
        },
        '& .text': {
          color: 'var(--text-strong)',
          fontWeight: 500,
          marginBottom: 6,
          fontSize: '0.9rem',
          wordBreak: 'break-word',
        },
      },
      hideOnMobile: {
        display: 'none',
      },


      leftCol: {
        display: 'flex',
        flexDirection: 'column',
        paddingRight: 8,
        marginTop: 5,
      },
      midCol: {
        marginTop: 5,
        display: 'flex',
        flexDirection: 'column',
        paddingRight: 8,
      },
      rightCol: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',

      },

      kvRow: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 5,
      },
      kvLabel: {
        color: 'var(--text-muted)',
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.2,
      },
      kvValue: {
        color: 'var(--text-strong)',
        fontSize: '0.9rem',
        fontWeight: 500,
        lineHeight: 1.35,
        wordBreak: 'break-word',
      },

      pdfIcon: {
        width: 40,
        height: 40,
        transform: 'translateX(14px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
        background: 'rgba(17,24,39,0.08)',
        border: '1px solid rgba(17,24,39,0.25)',
        cursor: 'pointer',
        padding: 0,
        '& img': {
          filter: 'brightness(0.4) contrast(1.35)',
          width: 20,
          height: 20,
        },
      },


    },
  }));
  return styles();
}
export default theme;

